import { StyleSheet } from "react-native";

export const termsAndConditionsStyles = StyleSheet.create({
  justify: {
    textAlign: "justify",
    textJustify: "inter-word",
  },
  list: {
    width: 30,
  },
});
